import { Component, OnInit } from '@angular/core';
import { ModalService } from '@lsq-frontend/common-ui';
import { GetSupplierDetailsForOperationsResponse } from '@lsq-frontend/remote-services/all-java/financing-mk1-services';

@Component({
    selector: 'send-supplier-enrollment-email-modal',
    styleUrls: ['./send-supplier-enrollment-email-modal.component.scss'],
    template: `
        <p class="body" [style.marginBottom]="'2rem'">
            Send a new enrollment email for the designated contact?
        </p>
        <data-card [style.marginBottom]="'2rem'">
            <p class="label">{{ supplierName }}</p>
            <p class="body">
                {{ supplierDetails.primaryContactFirstName }}
                {{ supplierDetails.primaryContactLastName }}
            </p>
            <p class="body">{{ supplierDetails.primaryContactEmailAddress }}</p>
        </data-card>
        <data-card>
            <p class="label">Notification Emails</p>
            <p class="body">
                {{
                    notificationEmails.length
                        ? notificationEmails.join(', ')
                        : 'No notification emails will be sent.'
                }}
            </p>
        </data-card>
    `
})
export class SendSupplierEnrollmentEmailModalComponent {
    public supplierDetails: GetSupplierDetailsForOperationsResponse;
    public supplierName: string;
    public notificationEmails: string[];

    constructor(private _modalService: ModalService) {
        this.supplierDetails = this._modalService.modal.data.supplierDetails;
        this.supplierName = this._modalService.modal.data.supplierName;
        this.notificationEmails = this._modalService.modal.data.notificationEmails;
    }
}
